import React from 'react';
import { LinearProgress, FormHelperText, Box } from '@material-ui/core';
import { validatePassword, getPasswordStrengthText, getPasswordStrengthColor } from '../utils/passwordValidation';

const PasswordStrengthIndicator = ({ password, showCriteria = true }) => {
	if (!password || password.length === 0) {
		return null;
	}

	const validation = validatePassword(password);
	const strengthText = getPasswordStrengthText(validation.strength);
	const strengthColor = getPasswordStrengthColor(validation.strength);

	const criteriaLabels = {
		length: 'Mínimo 8 caracteres',
		uppercase: 'Letra maiúscula',
		lowercase: 'Letra minúscula',
		number: 'Número',
		special: 'Caractere especial'
	};

	return (
		<Box style={{ marginTop: 8, marginBottom: 8 }}>
			<Box style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
				<Box style={{ flex: 1, marginRight: 8 }}>
					<LinearProgress
						variant="determinate"
						value={validation.strength}
						sx={{
							height: 6,
							borderRadius: 3,
							backgroundColor: '#e0e0e0',
							'& .MuiLinearProgress-bar': {
								backgroundColor: strengthColor
							}
						}}
					/>
				</Box>
				<FormHelperText style={{ margin: 0, color: strengthColor, fontWeight: 500, minWidth: 80 }}>
					{strengthText}
				</FormHelperText>
			</Box>
			{showCriteria && (
				<Box style={{ marginTop: 8 }}>
					{Object.entries(criteriaLabels).map(([key, label]) => (
						<FormHelperText
							key={key}
							style={{
								margin: '2px 0',
								color: validation.criteria[key] ? '#4caf50' : '#9e9e9e',
								fontSize: '0.75rem',
								display: 'flex',
								alignItems: 'center'
							}}
						>
							<span style={{ marginRight: 4 }}>
								{validation.criteria[key] ? '✓' : '○'}
							</span>
							{label}
						</FormHelperText>
					))}
				</Box>
			)}
		</Box>
	);
};

export default PasswordStrengthIndicator;
